import apiMiddleware from "../../../api/apiMiddleware";

// list suitable items with pagination and search
const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `suitable-master?page=${page}${search ? `&search=${search}` : ""}`
  );
  return response.data;
};

// create suitable item
const create = async (suitable) => {
  const response = await apiMiddleware.post("suitable-master", suitable);
  return response.data;
};

// get suitable item by id
const getById = async (id) => {
  const response = await apiMiddleware.get(`suitable-master/${id}`);
  return response.data;
};

// update suitable item
const update = async ({ id, suitable }) => {
  const response = await apiMiddleware.put(`suitable-master/${id}`, suitable);
  return response.data;
};

// delete suitable item
const deleteSuitable = async (id) => {
  const response = await apiMiddleware.delete(`suitable-master/${id}`);
  return response.data;
};

export { list, create, getById, update, deleteSuitable };
